import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import openNotification from '../../components/Common/OpenNotification';
import axiosInstance from '../../utils/axiosInstance';
import { UNIT_GET_DIRECT_MATERIAL_GRAPH, UNIT_GET_PERSONNEL_PAYMENT_GRAPH, ADMIN_QUATERLY_GRAPH, UNIT_GET_MISC_EXPENSES_GRAPH, UNIT_GET_INDIRECT_MATERIAL_GRAPH, UNIT_GET_POWER_GRAPH, UNIT_GET_EBITDA_GRAPH, UNIT_GET_PROFIT_LOSS_GRAPH, UNIT_GET_REVENUE_GRAPH, ADMIN_EXPORT_EXCEL, PMG_GET_PROJECTS_LISTING, PMG_GET_MS_CODE, PMG_ADD_PROJECT, PMG_EDIT_PROJECT, GET_INTERNAL_ORDER_MASTER_LISTING, EDIT_INTERNAL_ORDER_MASTER_LISTING, EDIT_INTERNAL_ORDER_MASTER, ADD_INTERNAL_ORDER_MASTER, GET_IO_INDAS_DATA_MAPPING_LISTING, ADD_IO_INDAS_DATA_MAPPING, EDIT_IO_INDAS_DATA_MAPPING, GET_IO_UNIT_MAPPING_LISTING, ADD_IO_UNIT_MAPPING, EDIT_IO_UNIT_MAPPING, GET_IO_ALLOCATIOn_LISTING, ADD_IO_ALLOCATION, EDIT_IO_ALLOCATION, ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES, ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS, ADMIN_OPERATING_PERFORMANCE_REPORT, ADMIN_NOTES_TO_OPERATING_REPORT, ADMIN_OPERATING_PERFORMANCE_REPORT_BY_UNIT, ADMIN_NOTES_TO_OPERATING_REPORT_BY_UNIT, ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES_BY_UNIT, ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS_BY_UNIT, ADMIN_OTHER_PROJECT_EXECUTION_PLAN, ADMIN_REV_NO_LOGS, ADMIN_REV_NO_UPLOAD, ADMIN_REV_NO_DOWNLOAD_TEMPLATE, ADMIN_IO_DELETION_UPLOAD, ADMIN_IO_DELETION_DOWNLOAD_MAPPING, ADMIN_IO_DELETION_LOGS, ADMIN_IO_DELETION_LIST, ADMIN_IO_DELETION_IGNORE, ADMIN_IO_DELETION_DELETE, ADMIN_SET_UPLOAD_LOCK, ADMIN_PROJECT_WISE_COST, ADMIN_MONITORING_PROJECT_LIST, ADMIN_UNIT_WISE_COST, ADMIN_PROJECT_WISE_COST_PER_MW } from '../../api/endpoints';

const initialState = {
        loading: false,
        directMaterial: [],
        personnelPayments: [],
        miscExpenses: [],
        indirectMaterial: [],
        power: [],
        ebitda: [],
        profitLossGraph: [],
        revenue: [],
        pmgProjectListing: [],
        msCodeListing: [],
        totalPmgProjectListing: '',
        internalOrderMasterListing: [],
        totalInternalOrderMasterListing: '',
        ioUnitMappingListing: [],
        totalIoUnitMappingListing: '',
        ioAllocationListing: [],
        totalIoAllocationListing: '',
        otherProjectExecutionPlan: [],
        revNoLogs: [],
        revNoLogsPagination: {},

        gettingRevNoLogs: false,
        uploadingRevNo: false,
        downloadingRevNoTemplate: false,
        downloadingIoDeletionTemplate: false,
        uploadingIoDeletion: false,

        ioDeletionLogs: [],
        ioDeletionLogsPagination: {},
        gettingIoDeletionLogs: false,

        ioDeletionList: [],
        ioDeletionListPagination: {},
        gettingIoDeletionList: false,

        ignoringIoDeletion: false,
        deletingIoDeletion: false,

        settingUploadLock: false,

        projectWiseCost: null,
        gettingProjectWiseCost: false,

        projectWiseCostPerMW: null,
        gettingProjectWiseCostPerMW: false,

        monitoringProjectList: [],
        gettingMonitoringProjectList: false,

        unitWiseCost: null,
        gettingUnitWiseCost: false,
};

export const getDirectMaterial = createAsyncThunk('unitReport/getDirectMaterial', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};
                const response = await axiosInstance.get(UNIT_GET_DIRECT_MATERIAL_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getquarterlyGraphData = createAsyncThunk('admin/quarterlyGraph', async (params, { rejectWithValue }) => {
        try {
                const payload = {
                        from_year: params.from_year,
                        to_year: params.to_year
                }
                const response = await axiosInstance.get(ADMIN_QUATERLY_GRAPH, {
                        params: payload,
                }
                );

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getPersonnelPaymentsReport = createAsyncThunk('unitReport/getPersonnelPaymentsReport', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_PERSONNEL_PAYMENT_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getMiscExpenses = createAsyncThunk('unitReport/getMiscExpenses', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_MISC_EXPENSES_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingPerformance = createAsyncThunk('adminUnitReport/getOperatingPerformance', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getNotesToOperating = createAsyncThunk('adminUnitReport/getNotesToOperating', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_NOTES_TO_OPERATING_REPORT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingMiscExpenses = createAsyncThunk('adminUnitReport/getOperatingMiscExpenses', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingPersonalPayment = createAsyncThunk('adminUnitReport/getOperatingPersonalPayment', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingPerformanceByUnit = createAsyncThunk('adminUnitReport/getOperatingPerformanceByUnit', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT_BY_UNIT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getNotesToOperatingByUnit = createAsyncThunk('adminUnitReport/getNotesToOperatingByUnit', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_NOTES_TO_OPERATING_REPORT_BY_UNIT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingMiscExpensesByUnit = createAsyncThunk('adminUnitReport/getOperatingMiscExpensesByUnit', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT_MISC_EXPENSES_BY_UNIT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperatingPersonalPaymentByUnit = createAsyncThunk('adminUnitReport/getOperatingPersonalPaymentByUnit', async (params, { rejectWithValue }) => {
        try {
                const queryParams = {
                        from_year: params?.from_year,
                        from_month: params?.from_month,
                        to_year: params?.to_year,
                        to_month: params?.to_month,
                        report_type: params?.report_type,
                        MNF_UNIT: params?.mnfUnit,
                };

                const response = await axiosInstance.get(ADMIN_OPERATING_PERFORMANCE_REPORT_PERSONNEL_PAYMENTS_BY_UNIT, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getIndirectMaterial = createAsyncThunk('unitReport/getIndirectMaterial', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_INDIRECT_MATERIAL_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getPower = createAsyncThunk('unitReport/getPower', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_POWER_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getEbitda = createAsyncThunk('unitReport/getEbitda', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_EBITDA_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getProfitLoss = createAsyncThunk('unitReport/getProfitLoss', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_PROFIT_LOSS_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getRevenue = createAsyncThunk('unitReport/getRevenue', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { MNF_UNIT: params.mnfUnit } : {};

                const response = await axiosInstance.get(UNIT_GET_REVENUE_GRAPH, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

// export const exportExcel = createAsyncThunk('unitReport/exportExcel', async ({ key, limit, page, type, IO_NO, REV_NO }, { rejectWithValue }) => {
//         try {
//                 const params = {
//                         is_export: true,
//                 };

//                 if (limit) params.limit = limit;
//                 if (page) params.page = page;
//                 if (type) params.TYPE = type;
//                 if (IO_NO) params.IO_NO = IO_NO;

//                 if (REV_NO) params.REV_NO = REV_NO;

//                 const endpoint = ADMIN_EXPORT_EXCEL[key];
//                 if (!endpoint) throw new Error('Invalid key provided for export.');

//                 openNotification('info', 'Download', `Downloading file under progress`);
//                 const response = await axiosInstance.get(endpoint, {
//                         params,
//                         responseType: 'blob', // ✅ get blob directly
//                 });

//                 // Format key for filename (e.g. PERSONNEL_PAYMENTS → Personnel_Payments)
//                 const formattedKey = key
//                         .replace(/_/g, ' ')
//                         .replace(/\b\w/g, (char) => char.toUpperCase())
//                         .replace(/ /g, '_');

//                 const fileName = `${formattedKey}.xlsx`;

//                 const blob = new Blob([response.data], {
//                         type: response.data.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                 });

//                 const link = document.createElement('a');
//                 const url = window.URL.createObjectURL(blob);
//                 link.href = url;
//                 link.download = fileName;

//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 window.URL.revokeObjectURL(url);

//                 openNotification('success', 'Download Successful', `${fileName} downloaded successfully.`);

//                 return true;
//         } catch (error) {
//                 openNotification('error', 'Download Failed', error?.message || 'Excel download failed.');
//                 return rejectWithValue(error?.message || 'Excel download failed.');
//         }
// });

export const getRevNoLogs = createAsyncThunk(
        "admin/getRevNoLogs",
        async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_REV_NO_LOGS,
                                {
                                        params: { page, limit },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const uploadRevNo = createAsyncThunk(
        "admin/uploadRevNo",
        async ({ data }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_REV_NO_UPLOAD,
                                {
                                        data,
                                }
                        );

                        openNotification(
                                "success",
                                "Upload Successful",
                                response.data.message
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Upload Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const downloadRevNoTemplate = createAsyncThunk(
        "admin/downloadRevNoTemplate",
        async (_, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_REV_NO_DOWNLOAD_TEMPLATE,
                                {},
                                {
                                        responseType: "blob",
                                }
                        );

                        const mime =
                                response?.data?.type ||
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                        const blob = new Blob([response.data], { type: mime });

                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "REV_NO_Template.xlsx";

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        return true;
                } catch (error) {
                        openNotification(
                                "error",
                                "Download Failed",
                                error?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.message || "Something went wrong."
                        );
                }
        }
);

export const downloadIoDeletionTemplate = createAsyncThunk(
        "admin/downloadIoDeletionTemplate",
        async (_, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_IO_DELETION_DOWNLOAD_MAPPING,
                                {},
                                {
                                        responseType: "blob",
                                }
                        );

                        const mime =
                                response?.data?.type ||
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                        const blob = new Blob([response.data], { type: mime });

                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "IO_Deletion_Template.xlsx";

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        return true;
                } catch (error) {
                        openNotification(
                                "error",
                                "Download Failed",
                                error?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.message || "Something went wrong."
                        );
                }
        }
);

export const uploadIoDeletion = createAsyncThunk(
        "admin/uploadIoDeletion",
        async ({ data }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_IO_DELETION_UPLOAD,
                                {
                                        data,
                                }
                        );

                        openNotification(
                                "success",
                                "Upload Successful",
                                response.data.message
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Upload Failed",
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );
                }
        }
);

export const getIoDeletionLogs = createAsyncThunk(
        "admin/getIoDeletionLogs",
        async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_IO_DELETION_LOGS,
                                {
                                        params: {
                                                page,
                                                limit,
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const getIoDeletionList = createAsyncThunk(
        "admin/getIoDeletionList",
        async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_IO_DELETION_LIST,
                                {
                                        params: {
                                                page,
                                                limit,
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const ignoreIoDeletion = createAsyncThunk(
        "admin/ignoreIoDeletion",
        async ({ id }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_IO_DELETION_IGNORE,
                                {
                                        id,
                                }
                        );

                        openNotification(
                                "success",
                                "Success",
                                response.data.message
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const deleteIoDeletion = createAsyncThunk(
        "admin/deleteIoDeletion",
        async ({ id }, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_IO_DELETION_DELETE,
                                {
                                        id,
                                }
                        );
                        openNotification(
                                "success",
                                "Success",
                                response.data.message, "Please Sync to reflect latest changes"
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const setUploadLock = createAsyncThunk(
        "admin/setUploadLock",
        async (payload, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.post(
                                ADMIN_SET_UPLOAD_LOCK,
                                payload
                        );

                        openNotification(
                                "success",
                                "Success",
                                payload.IS_UPLOAD_LOCKED
                                        ? "Unit locked successfully. Please Sync to view latest data changes"
                                        : "Unit unlocked successfully. Please Sync to view latest data changes"
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message || "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong."
                        );
                }
        }
);

export const exportExcel = createAsyncThunk(
        'unitReport/exportExcel',
        async ({ key, limit, page, type, IO_NO, REV_NO, params }, { rejectWithValue }) => {
                try {
                        const queryParams = {
                                is_export: true,
                        };

                        if (limit) queryParams.limit = limit;
                        if (page) queryParams.page = page;
                        if (type) queryParams.TYPE = type;
                        if (IO_NO) queryParams.IO_NO = IO_NO;
                        if (REV_NO) queryParams.REV_NO = REV_NO;

                        // filters from UI
                        if (params?.search) queryParams.search = params.search;
                        if (params?.MNF_UNIT) queryParams.MNF_UNIT = params.MNF_UNIT;

                        // month/year conversion
                        if (params?.from_date) {
                                queryParams.from_month = params.from_date.split('-')[1];
                                queryParams.from_year = params.from_date.split('-')[2];
                        }

                        if (params?.to_date) {
                                queryParams.to_month = params.to_date.split('-')[1];
                                queryParams.to_year = params.to_date.split('-')[2];
                        }

                        const endpoint = ADMIN_EXPORT_EXCEL[key];

                        openNotification('info', 'Download', `Downloading file under progress`);

                        const response = await axiosInstance.get(endpoint, {
                                params: queryParams,
                                responseType: 'blob',
                        });

                        const formattedKey = key
                                .replace(/_/g, ' ')
                                .replace(/\b\w/g, (char) => char.toUpperCase())
                                .replace(/ /g, '_');

                        const fileName = `${formattedKey}.xlsx`;

                        const blob = new Blob([response.data], {
                                type:
                                        response.data.type ||
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });

                        const link = document.createElement('a');
                        const url = window.URL.createObjectURL(blob);
                        link.href = url;
                        link.download = fileName;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);

                        openNotification('success', 'Download Successful', `${fileName} downloaded successfully.`);

                        return true;
                } catch (error) {
                        openNotification('error', 'Download Failed', error?.message || 'Excel download failed.');
                        return rejectWithValue(error?.message || 'Excel download failed.');
                }
        }
);

export const getPmgProjectListing = createAsyncThunk('unitReport/getPmgProjectListing', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { mnfUnit: params.mnfUnit } : {};

                if (params.page) queryParams.page = params.page;
                if (params.limit) queryParams.limit = params.limit;
                if (params.IO_NO) queryParams.IO_NO = params.IO_NO;
                if (params.REV_NO) queryParams.REV_NO = params.REV_NO;
                if (params.search) queryParams.search = params.search;

                const response = await axiosInstance.get(PMG_GET_PROJECTS_LISTING, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const addPmgProject = createAsyncThunk('unitReport/addPackage', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(PMG_ADD_PROJECT, params);

                console.log('api', response);

                return response.data;
        } catch (error) {
                console.log('error', error);

                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const editPmgProject = createAsyncThunk('unitReport/editPmgProject', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(PMG_EDIT_PROJECT, params);

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getInternalOrderMasterListing = createAsyncThunk('unitReport/getInternalOrderMasterListing', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { mnfUnit: params.mnfUnit } : {};

                if (params.page) queryParams.page = params.page;
                if (params.limit) queryParams.limit = params.limit;
                if (params.search) queryParams.search = params.search;

                const response = await axiosInstance.get(GET_INTERNAL_ORDER_MASTER_LISTING, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const addInternalOrderMaster = createAsyncThunk('unitReport/addPackage', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADD_INTERNAL_ORDER_MASTER, params);
                return response.data;
        } catch (error) {
                console.log('error', error);

                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const editInternalOrderMaster = createAsyncThunk('unitReport/editInternalOrderMaster', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(EDIT_INTERNAL_ORDER_MASTER, params);

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getIoIndasDataMappingListing = createAsyncThunk('unitReport/ioIndasDataMappingListing', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { mnfUnit: params.mnfUnit } : {};

                if (params.page) queryParams.page = params.page;
                if (params.limit) queryParams.limit = params.limit;
                if (params.search) queryParams.search = params.search;

                const response = await axiosInstance.get(GET_IO_INDAS_DATA_MAPPING_LISTING, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const addIoIndasDataMapping = createAsyncThunk('unitReport/addIoIndasDataMapping', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADD_IO_INDAS_DATA_MAPPING, params);
                return response.data;
        } catch (error) {
                console.log('error', error);

                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const editIoIndasDataMapping = createAsyncThunk('unitReport/editIoIndasDataMapping', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(EDIT_IO_INDAS_DATA_MAPPING, params);

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getMSCode = createAsyncThunk('unitReport/getMSCode', async (_, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(PMG_GET_MS_CODE);

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getIoUnitMappingListing = createAsyncThunk('unitReport/getIoUnitMappingListing', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { mnfUnit: params.mnfUnit } : {};

                if (params.page) queryParams.page = params.page;
                if (params.limit) queryParams.limit = params.limit;
                if (params.search) queryParams.search = params.search;

                const response = await axiosInstance.get(GET_IO_UNIT_MAPPING_LISTING, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const addIoUnitMapping = createAsyncThunk('unitReport/addIoUnitMapping', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADD_IO_UNIT_MAPPING, params);
                return response.data;
        } catch (error) {
                console.log('error', error);

                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const deleteIoUnitMapping = createAsyncThunk('unitReport/deleteIoUnitMapping', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.delete('/api/admin/io-unit-mapping', {
                        data: params, // ✅ pass body for DELETE
                });

                openNotification('success', 'Deleted', 'IO Unit deleted successfully.');
                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getIoAllocationListing = createAsyncThunk('unitReport/getIoAllocationListing', async (params, { rejectWithValue }) => {
        try {
                const queryParams = params?.mnfUnit ? { mnfUnit: params.mnfUnit } : {};

                if (params.page) queryParams.page = params.page;
                if (params.limit) queryParams.limit = params.limit;
                if (params.search) queryParams.search = params.search;

                const response = await axiosInstance.get(GET_IO_ALLOCATIOn_LISTING, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const addIoAllocation = createAsyncThunk('unitReport/addIoAllocation', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(ADD_IO_ALLOCATION, params);
                return response.data;
        } catch (error) {
                console.log('error', error);

                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getOtherProjectExecutionPlan = createAsyncThunk(
        "adminUnitReport/getOtherProjectExecutionPlan",
        async (params, { rejectWithValue }) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_OTHER_PROJECT_EXECUTION_PLAN,
                                {
                                        params,
                                }
                        );

                        return response.data;
                } catch (error) {
                        return rejectWithValue(
                                error?.response?.data?.message || "Something went wrong"
                        );
                }
        }
);
export const getProjectWiseCost = createAsyncThunk(
        "admin/getProjectWiseCost",
        async (
                { COST_LEVEL, VALUE_MODE, projects, MNF_UNIT, PRODUCT_CODE, PACKAGE_ID },
                { rejectWithValue }
        ) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_PROJECT_WISE_COST,
                                {
                                        params: {
                                                COST_LEVEL,
                                                VALUE_MODE,
                                                MNF_UNIT,
                                                projects: JSON.stringify(projects),
                                                PRODUCT_CODE: PRODUCT_CODE?.length ? JSON.stringify(PRODUCT_CODE) : undefined,
                                                PACKAGE_ID: PACKAGE_ID?.length ? JSON.stringify(PACKAGE_ID) : undefined,
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );
                }
        }
);

export const getProjectWiseCostPerMW = createAsyncThunk(
        "admin/getProjectWiseCostPerMW",
        async (
                { COST_LEVEL, VALUE_MODE, projects },
                { rejectWithValue }
        ) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_PROJECT_WISE_COST_PER_MW,
                                {
                                        params: {
                                                COST_LEVEL,
                                                VALUE_MODE,
                                                projects: JSON.stringify(projects),
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );
                }
        }
);

export const getMonitoringProjectList = createAsyncThunk(
        "admin/getMonitoringProjectList",
        async (
                { PROJECT_TYPE },
                { rejectWithValue }
        ) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_MONITORING_PROJECT_LIST,
                                {
                                        params: {
                                                PROJECT_TYPE,
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );
                }
        }
);

export const getUnitWiseCost = createAsyncThunk(
        "admin/getUnitWiseCost",
        async (
                {
                        COST_LEVEL,
                        VALUE_MODE,
                        PROJECT_TYPE,
                        projects,
                },
                { rejectWithValue }
        ) => {
                try {
                        const response = await axiosInstance.get(
                                ADMIN_UNIT_WISE_COST,
                                {
                                        params: {
                                                COST_LEVEL,
                                                VALUE_MODE,
                                                PROJECT_TYPE,
                                                projects: JSON.stringify(projects),
                                        },
                                }
                        );

                        return response.data;
                } catch (error) {
                        openNotification(
                                "error",
                                "Failed",
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );

                        return rejectWithValue(
                                error?.response?.data?.message ||
                                "Something went wrong."
                        );
                }
        }
);

export const editIoAllocation = createAsyncThunk('unitReport/editIoAllocation', async (params, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(EDIT_IO_ALLOCATION, params);

                return response.data;
        } catch (error) {
                openNotification('error', 'Error', error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

const unitReportSlice = createSlice({
        name: 'unitReport',
        initialState,
        reducers: {},
        extraReducers: (builder) => {
                builder.addCase(getDirectMaterial.pending, (state) => {
                        state.loading = true;
                        state.error = null;
                })
                        .addCase(getDirectMaterial.fulfilled, (state, action) => {
                                state.loading = false;
                                state.directMaterial = action.payload.data;
                        })
                        .addCase(getDirectMaterial.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getPersonnelPaymentsReport.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getPersonnelPaymentsReport.fulfilled, (state, action) => {
                                state.loading = false;
                                state.personnelPayments = action.payload.data;
                        })
                        .addCase(getPersonnelPaymentsReport.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getMiscExpenses.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getMiscExpenses.fulfilled, (state, action) => {
                                state.loading = false;
                                state.miscExpenses = action.payload.data;
                        })
                        .addCase(getMiscExpenses.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperatingPerformance.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingPerformance.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingPerformance = action.payload.data;
                        })
                        .addCase(getOperatingPerformance.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperatingPerformanceByUnit.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingPerformanceByUnit.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingPerformanceByUnit = action.payload.data;
                        })
                        .addCase(getOperatingPerformanceByUnit.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getNotesToOperating.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getNotesToOperating.fulfilled, (state, action) => {
                                state.loading = false;
                                state.notesToOperating = action.payload.data;
                        })
                        .addCase(getNotesToOperating.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getNotesToOperatingByUnit.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getNotesToOperatingByUnit.fulfilled, (state, action) => {
                                state.loading = false;
                                state.notesToOperatingByUnit = action.payload.data;
                        })
                        .addCase(getNotesToOperatingByUnit.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getOperatingMiscExpenses.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingMiscExpenses.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingMiscExpenses = action.payload.data;
                        })
                        .addCase(getOperatingMiscExpenses.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperatingMiscExpensesByUnit.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingMiscExpensesByUnit.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingMiscExpensesByUnit = action.payload.data;
                        })
                        .addCase(getOperatingMiscExpensesByUnit.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperatingPersonalPayment.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingPersonalPayment.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingPersonalPayment = action.payload.data;
                        })
                        .addCase(getOperatingPersonalPayment.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperatingPersonalPaymentByUnit.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperatingPersonalPaymentByUnit.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operatingPersonalPaymentByUnit = action.payload.data;
                        })
                        .addCase(getOperatingPersonalPaymentByUnit.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getIndirectMaterial.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getIndirectMaterial.fulfilled, (state, action) => {
                                state.loading = false;
                                state.indirectMaterial = action.payload.data;
                        })
                        .addCase(getIndirectMaterial.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getPower.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getPower.fulfilled, (state, action) => {
                                state.loading = false;
                                state.power = action.payload.data;
                        })
                        .addCase(getPower.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getEbitda.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getEbitda.fulfilled, (state, action) => {
                                state.loading = false;
                                state.ebitda = action.payload.data;
                        })
                        .addCase(getEbitda.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getProfitLoss.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProfitLoss.fulfilled, (state, action) => {
                                state.loading = false;
                                state.profitLossGraph = action.payload.data;
                        })
                        .addCase(getProfitLoss.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        .addCase(getRevenue.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getRevenue.fulfilled, (state, action) => {
                                state.loading = false;
                                state.revenue = action.payload.data;
                        })
                        .addCase(getRevenue.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getPmgProjectListing.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getPmgProjectListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.pmgProjectListing = action.payload.data?.data;
                                state.totalPmgProjectListing = action.payload.data?.totalCount;
                        })
                        .addCase(getPmgProjectListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getMSCode.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getMSCode.fulfilled, (state, action) => {
                                state.loading = false;
                                state.msCodeListing = action.payload.data;
                        })
                        .addCase(getMSCode.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getInternalOrderMasterListing.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getInternalOrderMasterListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.internalOrderMasterListing = action.payload.data?.data;
                                state.totalInternalOrderMasterListing = action.payload.data?.pagination?.total;
                        })
                        .addCase(getInternalOrderMasterListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getIoIndasDataMappingListing.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getIoIndasDataMappingListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.ioIndasDataMappingListing = action.payload.data?.data;
                                state.totalIndasDataMappingListing = action.payload.data?.pagination?.total;
                        })
                        .addCase(getIoIndasDataMappingListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getIoUnitMappingListing.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getIoUnitMappingListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.ioUnitMappingListing = action.payload.data?.data;
                                state.totalIoUnitMappingListing = action.payload.data?.pagination?.total;
                        })
                        .addCase(getIoUnitMappingListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getIoAllocationListing.pending, (state, action) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getIoAllocationListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.ioAllocationListing = action.payload.data?.data;
                                state.totalIoAllocationListing = action.payload.data?.pagination?.total;
                        })
                        .addCase(getIoAllocationListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getquarterlyGraphData.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getquarterlyGraphData.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectWiseProjectDetails = action?.payload?.data;
                                state.totalProjectWiseProjectDetails = action?.payload?.data?.pagination?.total;
                        })
                        .addCase(getquarterlyGraphData.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOtherProjectExecutionPlan.pending, (state) => {
                                state.loading = true;
                        })
                        .addCase(getOtherProjectExecutionPlan.fulfilled, (state, action) => {
                                state.loading = false;
                                state.otherProjectExecutionPlan = action.payload.data;
                        })
                        .addCase(getOtherProjectExecutionPlan.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getRevNoLogs.pending, (state) => {
                                state.gettingRevNoLogs = true;
                        })

                        .addCase(getRevNoLogs.fulfilled, (state, action) => {
                                state.gettingRevNoLogs = false;
                                state.revNoLogs = action.payload.data.data;
                                state.revNoLogsPagination = action.payload.data.pagination;
                        })

                        .addCase(getRevNoLogs.rejected, (state) => {
                                state.gettingRevNoLogs = false;
                        })
                        .addCase(uploadRevNo.pending, (state) => {
                                state.uploadingRevNo = true;
                        })

                        .addCase(uploadRevNo.fulfilled, (state) => {
                                state.uploadingRevNo = false;
                        })

                        .addCase(uploadRevNo.rejected, (state) => {
                                state.uploadingRevNo = false;
                        })
                        .addCase(downloadRevNoTemplate.pending, (state) => {
                                state.downloadingRevNoTemplate = true;
                        })

                        .addCase(downloadRevNoTemplate.fulfilled, (state) => {
                                state.downloadingRevNoTemplate = false;
                        })

                        .addCase(downloadRevNoTemplate.rejected, (state) => {
                                state.downloadingRevNoTemplate = false;
                        })
                        .addCase(downloadIoDeletionTemplate.pending, (state) => {
                                state.downloadingIoDeletionTemplate = true;
                        })

                        .addCase(downloadIoDeletionTemplate.fulfilled, (state) => {
                                state.downloadingIoDeletionTemplate = false;
                        })

                        .addCase(downloadIoDeletionTemplate.rejected, (state) => {
                                state.downloadingIoDeletionTemplate = false;
                        })
                        .addCase(uploadIoDeletion.pending, (state) => {
                                state.uploadingIoDeletion = true;
                        })

                        .addCase(uploadIoDeletion.fulfilled, (state) => {
                                state.uploadingIoDeletion = false;
                        })

                        .addCase(uploadIoDeletion.rejected, (state) => {
                                state.uploadingIoDeletion = false;
                        })
                        .addCase(getIoDeletionLogs.pending, (state) => {
                                state.gettingIoDeletionLogs = true;
                        })

                        .addCase(getIoDeletionLogs.fulfilled, (state, action) => {
                                state.gettingIoDeletionLogs = false;

                                state.ioDeletionLogs =
                                        action.payload.data.data;

                                state.ioDeletionLogsPagination =
                                        action.payload.data.pagination;
                        })

                        .addCase(getIoDeletionLogs.rejected, (state) => {
                                state.gettingIoDeletionLogs = false;
                        })
                        .addCase(getIoDeletionList.pending, (state) => {
                                state.gettingIoDeletionList = true;
                        })

                        .addCase(getIoDeletionList.fulfilled, (state, action) => {
                                state.gettingIoDeletionList = false;

                                state.ioDeletionList = action.payload.data.data;
                                state.ioDeletionListPagination = action.payload.data.pagination;
                        })

                        .addCase(getIoDeletionList.rejected, (state) => {
                                state.gettingIoDeletionList = false;
                        })
                        .addCase(ignoreIoDeletion.pending, (state) => {
                                state.ignoringIoDeletion = true;
                        })
                        .addCase(ignoreIoDeletion.fulfilled, (state) => {
                                state.ignoringIoDeletion = false;
                        })
                        .addCase(ignoreIoDeletion.rejected, (state) => {
                                state.ignoringIoDeletion = false;
                        })
                        .addCase(deleteIoDeletion.pending, (state) => {
                                state.deletingIoDeletion = true;
                        })

                        .addCase(deleteIoDeletion.fulfilled, (state) => {
                                state.deletingIoDeletion = false;
                        })

                        .addCase(deleteIoDeletion.rejected, (state) => {
                                state.deletingIoDeletion = false;
                        })
                        .addCase(setUploadLock.pending, (state) => {
                                state.settingUploadLock = true;
                        })

                        .addCase(setUploadLock.fulfilled, (state) => {
                                state.settingUploadLock = false;
                        })

                        .addCase(setUploadLock.rejected, (state) => {
                                state.settingUploadLock = false;
                        })
                        .addCase(getProjectWiseCost.pending, (state) => {
                                state.gettingProjectWiseCost = true;
                        })

                        .addCase(getProjectWiseCost.fulfilled, (state, action) => {
                                state.gettingProjectWiseCost = false;
                                state.projectWiseCost = action.payload.data;
                        })

                        .addCase(getProjectWiseCost.rejected, (state) => {
                                state.gettingProjectWiseCost = false;
                        })
                        .addCase(getProjectWiseCostPerMW.pending, (state) => {
                                state.gettingProjectWiseCostPerMW = true;
                        })

                        .addCase(getProjectWiseCostPerMW.fulfilled, (state, action) => {
                                state.gettingProjectWiseCostPerMW = false;
                                state.projectWiseCostPerMW = action.payload.data;
                        })

                        .addCase(getProjectWiseCostPerMW.rejected, (state) => {
                                state.gettingProjectWiseCostPerMW = false;
                        })
                        .addCase(getUnitWiseCost.pending, (state) => {
                                state.gettingUnitWiseCost = true;
                        })

                        .addCase(getUnitWiseCost.fulfilled, (state, action) => {
                                state.gettingUnitWiseCost = false;
                                state.unitWiseCost = action.payload.data;
                        })

                        .addCase(getUnitWiseCost.rejected, (state) => {
                                state.gettingUnitWiseCost = false;
                        })
                        .addCase(getMonitoringProjectList.pending, (state) => {
                                state.gettingMonitoringProjectList = true;
                        })
                        .addCase(getMonitoringProjectList.fulfilled, (state, action) => {
                                state.gettingMonitoringProjectList = false;
                                state.monitoringProjectList = action.payload;
                        })
                        .addCase(getMonitoringProjectList.rejected, (state) => {
                                state.gettingMonitoringProjectList = false;
                                state.monitoringProjectList = [];
                        });

        },
});

export default unitReportSlice.reducer;

